export const parseRemotePartyId = (header: string): string | undefined => {
  const result = header.match(/"(.*?)"/)
  return result && result[1] ? result[1] : undefined
}
